module.exports = __webpack_public_path__ + "img/s.6373a5c9.png";